import { ScanSearch } from "lucide-react";
import { toast } from "sonner";
import { decodeCF } from "../lib/cfDecode";

// Pulsante riusabile "Decodifica CF". Opera lato client (nessuna chiamata esterna).
// onDecode(data) riceve i campi decodificati; ogni form li mappa ai propri nomi.
export default function DecodificaCFButton({ cf, onDecode, testId = "decodifica-cf", className = "" }) {
  const run = () => {
    const r = decodeCF(cf);
    if (!r.ok) { toast.error(r.error); return; }
    onDecode(r.data);
    toast.warning(
      "Dati di nascita, sesso e luogo compilati dal CF. ATTENZIONE: cognome e nome sono APPROSSIMATIVI (dal CF si ricavano solo le consonanti) — verificali e correggili.",
      { duration: 7000 }
    );
  };
  return (
    <button type="button" data-testid={testId} onClick={run} title="Decodifica il codice fiscale (cognome/nome approssimativi)"
      className={`inline-flex items-center gap-1 rounded-md border border-cyan-500/50 text-cyan-300 hover:bg-cyan-500/10 text-xs px-2 py-1 whitespace-nowrap transition-colors ${className}`}>
      <ScanSearch className="h-3.5 w-3.5" /> Decodifica CF
    </button>
  );
}
